import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DEFAULT_FILE_TYPES, isFileTypeAllowed, isFileSizeAllowed } from '@certemy/ui-components';
import { CustomFields } from 'features/custom-fields/custom-fields.interface';

@Component({
  selector: 'cm-instance-custom-attachment',
  templateUrl: './instance-custom-attachment.component.html',
  styleUrls: ['./instance-custom-attachment.component.scss'],
})
export class InstanceCustomAttachmentComponent {
  @Input()
  set files(files: CustomFields.Attachment[]) {
    this.controlFiles = [...files, ...this.invalidFiles];
  }
  @Input() label: string;
  @Input() readOnly = false;
  @Output() upload = new EventEmitter<File[]>();
  @Output() remove = new EventEmitter<CustomFields.Attachment>();
  allowedTypes = DEFAULT_FILE_TYPES;
  controlFiles: (CustomFields.Attachment | File)[] = [];
  readonly FILE_SIZE = 30;
  private invalidFiles: File[] = [];

  onRemove(fileToRemove: CustomFields.Attachment) {
    if (this.isFileValid(fileToRemove)) {
      this.remove.emit(fileToRemove);
    } else {
      this.invalidFiles = this.invalidFiles.filter(file => file.name !== fileToRemove.name);
      this.controlFiles = this.controlFiles.filter(file => file.name !== fileToRemove.name);
    }
  }

  onFilesSelect(files: File[]) {
    const { valid, invalid } = this.sortFiles(files);

    this.invalidFiles = [...this.invalidFiles, ...invalid];
    this.controlFiles = [...this.controlFiles, ...valid, ...invalid];

    if (valid.length) {
      this.upload.emit(valid);
    }
  }

  private isFileValid(file: File | CustomFields.Attachment): boolean {
    return isFileSizeAllowed(file.size, this.FILE_SIZE) && isFileTypeAllowed(file.name, this.allowedTypes);
  }

  private sortFiles(files: File[]): { valid: File[]; invalid: File[] } {
    const valid = files.filter(file => this.isFileValid(file));
    const invalid = files.filter(file => !this.isFileValid(file));

    return { valid, invalid };
  }
}
